module.exports = __webpack_public_path__ + "c9b8ef4fa17b1dd90ffaca901896b87f.svg";